import React from 'react';
import { ForgeIcon } from '@tylertech/forge-react';
import { FORGE_AI_ICON } from '../../PBBStrategist/pbbStrategistHelpers.js';

export const ARIA_HIDDEN = 'true';
export const SLOT = 'start';

export const renderIcon = (iconName, selected) => {
  if (iconName === FORGE_AI_ICON) return <forge-ai-icon class={`defaultIconSize ${selected ? 'defaultIconColorSelected' : 'defaultIconColor'}`} external slot={SLOT} aria-hidden={ARIA_HIDDEN} />;
  return <ForgeIcon external slot={SLOT} name={iconName} aria-hidden={ARIA_HIDDEN} />;
};
